/**
 * Shared form fields for organization create/edit.
 *
 * Organizations are user records (role 'organization'). On creation the
 * backend requires the owning client (`client_id`); superadmins pick it
 * from the client list, organization owners create under themselves.
 */

import {
  TextInput,
  SelectInput,
  email,
  required,
  useGetList,
  usePermissions,
  useTranslate,
} from 'react-admin';
import { USER_ROLES } from '@/config/constants';

export const OrganizationFormFields = ({ isCreate }: { isCreate: boolean }) => {
  const translate = useTranslate();
  const { permissions } = usePermissions();
  const isAdmin = permissions === USER_ROLES.ADMIN;

  const { data: clients } = useGetList('users', {
    filter: { role: 4 },
    pagination: { page: 1, perPage: 500 },
    sort: { field: 'full_name', order: 'ASC' },
  });

  return (
    <>
      <TextInput source="full_name" validate={required()} />
      <TextInput source="email" type="email" validate={[required(), email()]} />
      {isCreate && (
        <TextInput
          source="password"
          type="password"
          validate={required()}
          autoComplete="new-password"
        />
      )}
      {isCreate && isAdmin && (
        <SelectInput
          source="client_id"
          validate={required()}
          choices={(clients ?? []).map((client: any) => ({
            id: client.user_id,
            name: `${client.full_name} (${client.email})`,
          }))}
          label={translate('resources.organizations.fields.client_id')}
        />
      )}
      <TextInput source="company_name" />
      <TextInput source="contact_no" />
      <TextInput source="address" />
      <TextInput source="city" />
      <TextInput source="postal_code" />
      {!isCreate && (
        <SelectInput
          source="status"
          choices={[
            { id: 1, name: translate('common.status.active', { _: 'Activa' }) },
            { id: 0, name: translate('common.status.inactive', { _: 'Inactiva' }) },
          ]}
        />
      )}
    </>
  );
};

export default OrganizationFormFields;
